import { EntityType } from "@mapmycustomers/shared/enum";
import { MapSavedFilter } from "@mapmycustomers/shared/types/viewModel/SavedFilter";

import { MAP_FILTER_KEYS } from "@app/util/filters/isMapFilterWebCompatible";

// A route can't stop at a deal, so only a filter scoped exclusively to deals is left out
const isRouteEligibleSavedFilter = ({ filters }: MapSavedFilter): boolean =>
  !filters[EntityType.DEAL]?.conditions.length ||
  MAP_FILTER_KEYS.some((key) => key !== EntityType.DEAL && !!filters[key]?.conditions.length);

export default isRouteEligibleSavedFilter;
